<template>
  <div class="coupon-list">
    <div class="coupon-item" :class="[item.state !== 1 && item.state !==4 ? 'graybg' : '']" v-for="item in couponList" :key="item.id">
      <div class="left-box">
        <div class="price">{{'¥' + money(item.batchMoney)}}</div>
        <div class="limit">- {{formatLimit(item.limitMoney)}} -</div>
        <span class="circle"></span>
      </div>
      <div class="right-box">
        <h3 class="title">{{item.showTitle}}</h3>
        <div class="time" v-if="item.relativeTime">有效期{{item.relativeTime}}天，单次限使用1张</div>
        <!-- <div class="time">有效期1个月，单次限使用1张</div> -->
      </div>
      <div>
        <div class="coupon-btn">
          <!-- // 1:可领取，2:已领取，3:已抢光，4:未开始  5:不符合条件 6：已结束 -->
          <img v-if="item.state === 1" src="../../assets/images/couponTunnel/btn1.png" width="100%" @click="getCoupon(item)"/>
          <img v-if="item.state === 2" src="../../assets/images/couponTunnel/btn2.png" width="100%" @click="viewCoupon()" />
          <img v-if="item.state === 3" src="../../assets/images/couponTunnel/btn3.png" width="100%" />
          <img v-if="item.state === 4" src="../../assets/images/couponTunnel/btn4.png" width="100%" />
          <img v-if="item.state === 6" src="../../assets/images/couponTunnel/btn6.png" width="100%" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    couponList: {
      type: Array,
      default: () => []
    },
    isDown: {}
  },
  methods: {
    // 1:可领取，2:已领取，3:已抢光，4:未开始  5:不符合条件 6：已结束
    formatLimit (limitMoney) {
      let str = ''
      if (!limitMoney || limitMoney === '0.00') {
        str = '无门槛'
      } else {
        str = `满${limitMoney}可用`
      }
      return str
    },
    money (batchMoney) {
      return batchMoney > 0 ? batchMoney : 0
    },
    getCoupon (item) {
      this.$emit('getCoupon', item)
    },
    viewCoupon (item) {
      this.$emit('viewCoupon', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-list {
  border-radius: 5px;
  margin: 20px;
}
.coupon-title {
  width: 50%;
  margin: 4% 25%;
  img {
    display: block;
  }
}
.coupon-item {
  position: relative;
  min-height: 70px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 4px 10px;
  border-radius: 5px;
  background: #F14950;
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  &:last-child {
    margin-bottom: 0;
  }
  .left-box {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    align-items: center;
    width: 78px;
    min-height: 54px;
    position: relative;
    padding: 3px 6px;
    color: #E60026;
    background: #fff;
    font-weight: 700;
    border-radius: 5px 0 0 5px;
    overflow: hidden;
    .price {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 25px;
      text-align: center;
    }
    .limit {
      width: 100%;
      font-size: 12px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transform: scale(0.9);
    }
    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #F14950;
      position: absolute;
      top: 50%;
      left: -5px;
      margin-top: -5px;
    }
  }
  .right-box {
    flex: 1;
    padding: 0 5px;
    overflow: hidden;
    line-height: 1.6;
    text-align: center;
    .title {
      font-size: 16px;
      font-weight: 700;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0px 5px;
    }
    .time {
      display: inline-flex;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 1px 6px;
      border-radius: 15px;
      background: #F4212D;
      font-size: 12px;
      transform: scale(0.8);
    }
    .sale {
      font-size: 12px;
      transform: scale(0.8);
      margin-left: -20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      display: inline-block;
      margin-left: 2px;
      padding: 1px 8px;
      background: #EC5A3F;
      border-radius: 20px;
      transform: scale(0.9);
      vertical-align: middle;
    }
  }
  .coupon-btn {
    width: 50px;
  }
}
.coupon-item.graybg {
  opacity: 0.5;
}
</style>
